import React from 'react';
import { graphql } from 'gatsby';
import { Layout } from '@components/Layout';
import { createComponent } from '@helpers/createComponent';
import { initDataLayer } from '@helpers/dataLayerPush';

const Page = ({ data, location }) => {
  const { title, seo, body } = data.strapiLandingPage;

  initDataLayer();

  return (
    <Layout
      seo={{ ...seo, metaTitle: seo.metaTitle || title }}
      location={location}>
      {body.map((props, index) => createComponent({ ...props, index }))}
    </Layout>
  );
};

export const query = graphql`
  query ($url: String) {
    strapiLandingPage(url: { eq: $url }) {
      title
      url
      seo {
        metaTitle
        metaDescription
        metaImage {
          localFile {
            childImageSharp {
              fluid {
                src
              }
            }
          }
          alternativeText
        }
        metaRobots
        keywords
        noIndex
      }
      body {
        ...Body
      }
    }
  }
`;

export default Page;

export { Head } from '@components/molecules/SEO';
